import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "../context/AuthContext";
import { toast } from "sonner";
import { Gift, Mail, CheckCircle2, Plus, Trash2 } from "lucide-react";

const inp = "w-full bg-black/40 border border-white/10 rounded-md px-3 py-2 text-sm outline-none focus:border-[#FF1E27]";

export default function AdminPrizes() {
  const [prizes, setPrizes] = useState([]);
  const [winners, setWinners] = useState([]);
  const load = async () => {
    const [{ data: lb }, { data: w }] = await Promise.all([axios.get(`${API}/paddock/season/leaderboard`), axios.get(`${API}/admin/season/winners`)]);
    setPrizes(lb.prizes); setWinners(w);
  };
  useEffect(() => { load(); }, []);
  const save = async () => { await axios.put(`${API}/admin/season/prizes`, { prizes }); toast.success("Premi salvati"); load(); };
  const mark = async (uid, status) => { await axios.put(`${API}/admin/season/winners/${uid}`, { status }); load(); };
  const upd = (i, k, v) => setPrizes(prizes.map((p, j) => j === i ? { ...p, [k]: v } : p));

  return (
    <div className="grid lg:grid-cols-2 gap-6" data-testid="admin-prizes">
      <div className="rl-card p-6">
        <h2 className="font-display font-bold text-xl flex items-center gap-2 mb-1"><Gift className="w-5 h-5 text-[#FF1E27]" /> Premi stagionali</h2>
        <p className="text-xs text-slate-500 mb-4">Visibili nella pagina Campionato Fan. Un premio per posizione.</p>
        <div className="space-y-2">
          {prizes.map((p, i) => (
            <div key={i} className="grid grid-cols-12 gap-2 items-center" data-testid={`prize-row-${p.pos}`}>
              <input className={`${inp} col-span-2`} type="number" value={p.pos} onChange={e => upd(i, "pos", parseInt(e.target.value) || 1)} data-testid={`prize-pos-${i}`} />
              <input className={`${inp} col-span-6`} value={p.title} onChange={e => upd(i, "title", e.target.value)} placeholder="Premio" data-testid={`prize-title-${i}`} />
              <input className={`${inp} col-span-3`} value={p.sponsor || ""} onChange={e => upd(i, "sponsor", e.target.value)} placeholder="Sponsor" data-testid={`prize-sponsor-${i}`} />
              <button onClick={() => setPrizes(prizes.filter((_, j) => j !== i))} className="text-slate-500 hover:text-[#FF1E27]" data-testid={`prize-del-${i}`}><Trash2 className="w-4 h-4" /></button>
            </div>
          ))}
        </div>
        <div className="flex gap-2 mt-4">
          <button className="btn-outline-rl !py-2 text-xs" onClick={() => setPrizes([...prizes, { pos: prizes.length + 1, title: "", sponsor: "" }])} data-testid="prize-add"><Plus className="w-4 h-4 inline" /> AGGIUNGI</button>
          <button className="btn-crimson !py-2 text-xs" onClick={save} data-testid="prize-save">SALVA PREMI</button>
        </div>
      </div>
      <div className="rl-card p-6">
        <h2 className="font-display font-bold text-xl flex items-center gap-2 mb-1"><Mail className="w-5 h-5 text-[#FF9F0A]" /> Fan vincitori da contattare</h2>
        <p className="text-xs text-slate-500 mb-4">Classifica stagionale attuale. Contatta i vincitori e segna lo stato.</p>
        <div className="space-y-2">
          {winners.map(w => (
            <div key={w.user_id} className={`border rounded-lg px-3 py-2 text-sm ${w.prize ? "border-[#FF9F0A]/40" : "border-white/5"}`} data-testid={`winner-row-${w.pos}`}>
              <div className="flex items-center justify-between gap-2">
                <div><span className="font-display font-black text-[#FF9F0A] mr-2">P{w.pos}</span>{w.name} <span className="font-mono-rl text-xs text-slate-400">{w.points} pt</span></div>
                {w.contacted ? <span className="text-[10px] font-mono-rl text-[#30D158] flex items-center gap-1"><CheckCircle2 className="w-3 h-3" /> {w.contacted}</span>
                  : <button className="text-[10px] font-mono-rl text-slate-400 hover:text-white" onClick={() => mark(w.user_id, "CONTATTATO")} data-testid={`winner-mark-${w.pos}`}>SEGNA CONTATTATO</button>}
              </div>
              <div className="text-xs text-slate-400 flex flex-wrap gap-3 mt-1">
                {w.email && <a className="text-[#00F0FF] hover:underline" href={`mailto:${w.email}?subject=${encodeURIComponent("Rally Love · hai vinto un premio del Campionato Fan!")}`} data-testid={`winner-mail-${w.pos}`}>{w.email}</a>}
                {w.prize && <span>🎁 {w.prize.title}{w.prize.sponsor ? ` (${w.prize.sponsor})` : ""}</span>}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
